
export const enum SalaryFrequency {
    Weekly = 'weekly',
    Monthly = 'monthly',
    Annually = 'annually',
    Fortnightly = 'fortnightly',
  }